"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemCheckboxGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/menu-item/menu-item-group");
require("@/components/common/menu-item/semantics/menu-item-checkbox");
const multiple_selection_controller_1 = require("@/controllers/multiple-selection-controller");
const slotted_selection_controller_1 = require("@/controllers/slotted-selection-controller");
const utils_1 = require("@/utils");
/**
 * mm-menu-item-checkbox를 묶는 다중 선택 그룹.
 * 선택된 value 목록을 values prop으로 관리하며
 * 변경 시 change 이벤트를 발행합니다.
 */
let MenuItemCheckboxGroup = class MenuItemCheckboxGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.ariaLabel = '';
        this.values = [];
        this.selection = new multiple_selection_controller_1.MultipleSelectionController({
            getValues: () => this.values,
            setValues: values => {
                this.values = values;
            },
            getOptions: () => this.checkboxes.map(checkbox => ({ value: (0, slotted_selection_controller_1.selectionItemValue)(checkbox) })),
        });
        this.group = new slotted_selection_controller_1.SlottedSelectionController(this, {
            selection: this.selection,
            getItems: () => this.checkboxes,
            onChange: () => {
                (0, utils_1.emit)(this, 'change', { values: this.values });
            },
        });
    }
    render() {
        return (0, lit_1.html) `
      <mm-menu-item-group
        role="group"
        size=${this.size}
        aria-label=${this.ariaLabel || lit_1.nothing}
        @change=${this.group.handleItemChange}
      >
        <slot @slotchange=${this.group.handleSlotChange}></slot>
      </mm-menu-item-group>
    `;
    }
};
MenuItemCheckboxGroup.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MenuItemCheckboxGroup.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], MenuItemCheckboxGroup.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], MenuItemCheckboxGroup.prototype, "values", void 0);
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ selector: 'mm-menu-item-checkbox' })
], MenuItemCheckboxGroup.prototype, "checkboxes", void 0);
MenuItemCheckboxGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-menu-item-checkbox-group')
], MenuItemCheckboxGroup);
exports.MenuItemCheckboxGroup = MenuItemCheckboxGroup;
//# sourceMappingURL=data:application/json;base64,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